import React from 'react'
import { Modal } from 'theorem-lib/src/components/molecules/Modal/Modal'
import { useActions, useAppState } from '../../../presenter'

export const ProjectCreationModal = () => {
  const { currentModal } = useAppState()
  const { displayModalAction } = useActions()

  const onClose = () => {
    displayModalAction('None')
  }

  return (
    <Modal
      isOpen={currentModal === 'ProjectCreationModal'}
      onClose={onClose}
      shouldCloseOnEsc={false}
      contentStyle={{
        width: '486px',
      }}
    >
      <div className='flex flex-col justify-center items-center w-full[80vw] sm:w-full'>
        <div className='text-primary-100 text-xl font-bold mt-4 mb-4 text-center'>
          You’ve created a new project! 🎉
        </div>
        <div className='px-4 text-primary-300 text-base font-normal text-center mb-4'>
          <p className='mb-4'>{'We are currently reviewing your project & assigning the appropriate team members. '}</p>
          <p className='mb-4'>
            In the meantime, please select a cover image and make sure your profile info is up to date!
          </p>
        </div>
        <div className='flex flex-row'>
          <button type='button' className='button cta mx-2' onClick={onClose}>View Project Details</button>
        </div>
      </div>
    </Modal>
  )
}
